import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Button } from "primereact/button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import Select from "@mui/material/Select";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FicheLogTerminal from "./journal";
import { TextField, TextareaAutosize } from "@mui/material";
import { fr } from "date-fns/locale";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import formatToISODate from "../formatDateISO";
import { Calendar } from "primereact/calendar";
import DevisDialog from "./DevisDialog";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import { format } from "date-fns";

import convertTimeStringToDate from "../timeToDate";

import {
  formatDateWithDaysAgo,
  clientTemplate,
  contactTemplate,
  invitesTemplate,
  typeTemplate,
  nameTemplate,
  phoneTemplate,
  emailTemplate,
  amountTemplate
} from './formatTableau';

const apiUrl = process.env.REACT_APP_API_URL;

export default function Relances({ searchTerm = "" }) {
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(true);

  const [ficheLeadsSuivis, setFicheLeadsSuivis] = useState([]);

  const [copiedText, setCopiedText] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [openSnackbarMail, setOpenSnackbarMail] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [visible, setVisible] = useState(false);

  const [rechercheSuivis, setRechercheSuivis] = useState("");

  const [tempIdFicheLead, setTempIdFicheLead] = useState("");
  const [tempNom, setTempNom] = useState("");
  const [tempEmail, setTempEmail] = useState("");
  const [tempTel, setTempTel] = useState("");
  const [tempLieu, setTempLieu] = useState("");
  const [tempNbpers, setTempNbpers] = useState("");
  const [tempHeuredebut, setTempHeuredebut] = useState("");
  const [tempTypeBar, setTempTypeBar] = useState("");
  const [tempBarman, setTempBarman] = useState("");
  const [tempMore, setTempMore] = useState("");
  const [nbAppels, setNbAppels] = useState("");
  const [tempDateEvent, setTempDateEvent] = useState("");

  const [ficheListeFiltre, setFicheListeFiltre] = useState("");
  const [note, setNote] = useState("");

  const [appel, setAppel] = useState("");
  const [date, setDate] = useState(null);

  const [dateValidation, setDateValidation] = useState(null);
  const [dateDevis, setDateDevis] = useState(null);

  const [tempStatus, setTempStatus] = useState("");

  const [heureDem, setHeureDem] = useState("");

  const [devisDialogVisible, setDevisDialogVisible] = useState(false);
  const [currentLeadForDevis, setCurrentLeadForDevis] = useState(null);

  const [forceNewDevis, setForceNewDevis] = useState(false);


  const openDevisDialog = (leadData, isNew = false) => {
    setForceNewDevis(isNew);
    setCurrentLeadForDevis({
      idLead: leadData.idLead,
      nomPrenom: leadData.nomPrenom,
      email: leadData.email,
      tel: leadData.tel,
      lieu: leadData.lieu,
      type_bar:leadData.type_bar,
      dateEvent:leadData.dateFicheLead,
      nbpers: leadData.nbpers,
      plusInfos:leadData.more
    });
    setDevisDialogVisible(true);
  };

  const handleDevisGenerated = () => {
    axios
      .get(`${apiUrl}/IHM/api/lead.php?relances`)
      .then((response) => {
        // setFicheLeadsSuivis(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du rechargement :", error);
      });
  };

  const getLabel = () => {
    switch (appel) {
      case "0":
        return "Nouvelle";
      case "1":
        return "En cours";
      case "2":
        return "Suivis";
      case "3":
        return "Validés";
      case "4":
        return "Réalisés";
      case "5":
        return "Abandons";
      default:
        return "inconnus";
    }
  };

  const copyToClipboard = (text) => {
    if (text !== "") {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            setCopiedText(text);
            setOpenSnackbar(true);
          })
          .catch((error) => {
            console.error(
              "Erreur lors de la copie dans le presse-papiers : ",
              error,
            );
          });
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        setCopiedText(text);
        setOpenSnackbar(true);
      }
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };
  const handleCloseSnackbarMail = () => {
    setOpenSnackbarMail(false);
  };

  useEffect(() => {
    axios
      .get(`${apiUrl}/IHM/api/lead.php?relances`)
      .then((response) => {
       setFicheLeadsSuivis(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des factures :", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const recherche = searchTerm.toLowerCase();
    const filteredList = ficheLeadsSuivis.filter((fiche) => {
      const nomPrenom = fiche.nomPrenom?.toLowerCase() || "";
      const tel = fiche.tel?.toLowerCase() || "";
      const lieu = fiche.lieu?.toLowerCase() || "";
      const email = fiche.email?.toLowerCase() || "";
      return (
        nomPrenom.includes(recherche) ||
        tel.includes(recherche) ||
        lieu.includes(recherche) ||
        email.includes(recherche)
      );
    });
    setFicheListeFiltre(filteredList);
  }, [searchTerm, ficheLeadsSuivis]);




const sendMailRelance = async (leadData) => {
  try {
    const response = await axios.post(`${apiUrl}/IHM/api/sendMailRelanceDevis.php`, {
      id: leadData.idLead,
      adminMod: localStorage.getItem("us")
    });
    
    if (response.data.success) {
      setSnackbarMessage(`Mail de relance envoyé à ${leadData.email}`);
      setOpenSnackbarMail(true);
      
      axios.get(`${apiUrl}/IHM/api/lead.php?relances`)
        .then((res) => setFicheLeadsSuivis(res.data));
    } else {
      setSnackbarMessage(response.data.message || "Erreur lors de l'envoi");
      setOpenSnackbarMail(true);
    }
  } catch (error) {
    console.error("Erreur:", error);
    setSnackbarMessage("Erreur lors de l'envoi du mail");
    setOpenSnackbar(true);
  }
};
  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbarMail}
        autoHideDuration={1000}
        onClose={handleCloseSnackbarMail}
        message={snackbarMessage}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbarMail}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message={`Copie réussie de " ${
          copiedText === "location.mail" ? "e-mail" : copiedText
        } "`}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <DevisDialog
        visible={devisDialogVisible}
        onHide={() => {
          setDevisDialogVisible(false);
          setForceNewDevis(false);
        }}
        leadData={currentLeadForDevis}
        onDevisGenerated={() => {
          handleDevisGenerated();
          setForceNewDevis(false);
        }}
        forceNew={forceNewDevis}
      />
      <DataTable
        value={ficheListeFiltre}
        paginator
        size="small"
        rows={100}
        rowsPerPageOptions={[100, 200]}
        tableStyle={{ minWidth: "50rem" }}
        scrollable
        scrollDirection="horizontal"
        paginatorTemplate={
          "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
        }
        paginatorRight={
          <span style={{ margin: "10px", fontWeight: "bold" }}>
            Résultats : {ficheListeFiltre.length}
          </span>
        }
        loading={loading}
        loadingIcon="pi pi-spin pi-spinner"
        emptyMessage={
          loading
            ? "Chargement des nouvelles fiches..."
            : "Aucune fiche pour le moment"
        }
      >
        <Column
          field="dateUpdate"
          header="Date"
          body={(rowData) => formatDateWithDaysAgo(rowData.dateUpdate)}
        />

        <Column
          field="nom"
          header="Client"
          body={(rowData) => nameTemplate(rowData, copyToClipboard)}
        />

        <Column
          field="email"
          header="Contact"
          body={(rowData) => contactTemplate(rowData, copyToClipboard)}
        />

        <Column
          field="nbpers"
          header="Invités"
          body={(rowData) => invitesTemplate(rowData, copyToClipboard)}
        />

        <Column
          field="type_bar"
          header="Type"
          body={(rowData) => typeTemplate(rowData, copyToClipboard)}
        />

        <Column
          header="Actions"
          style={{ textAlign: "center", width: "100px" }}
          body={(rowData) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "5px",
              }}
            >
              <Button
                icon="pi pi-envelope"
                severity="success"
                text
                raised
                size="small"
                tooltip="Mail de relance"
                tooltipOptions={{
                  position: "top",
                  style: { fontSize: "0.7rem" },
                }}
                onClick={() => sendMailRelance(rowData)}
              />

              {rowData.a_devis == 1 && (
                <>
                  <Button
                    icon="pi pi-file-pdf"
                    severity="info"
                    text
                    raised
                    size="small"
                    tooltip="Gérer le devis"
                    tooltipOptions={{
                      position: "top",
                      style: { fontSize: "0.7rem" },
                    }}
                    onClick={() => openDevisDialog(rowData, false)}
                  />
                  <Button
                    icon="pi pi-plus"
                    severity="warning"
                    text
                    raised
                    size="small"
                    tooltip="Nouveau devis"
                    tooltipOptions={{
                      position: "top",
                      style: { fontSize: "0.7rem" },
                    }}
                    onClick={() => openDevisDialog(rowData, true)}
                  />
                </>
              )}
            </div>
          )}
        />
      </DataTable>
    </>
  );
}
